import Axios from 'axios';
import config from './config';
import request from './request';

async function get_token(){
        // 微信端授权
    let code = new URLSearchParams(window.location.search).get('code');

    // 获取授权
    let res = await request({
        url: "/h5/Login/getLoginToken",
        method: "post",
        params: {code:code},
        no_close_loading: true,
    })
    let token = res.data.data.token
    if(res.data.data.wx_power==0){// 进行强制授权
        let hash = window.location.hash.substring(2)
        let all_param = '&all_param='
        all_param += encodeURIComponent( sessionStorage.getItem('all_param'));
        all_param += "&address=";
        all_param += encodeURIComponent(hash);
        let ENCode_URL = encodeURIComponent(window.location.origin+"/h5/login/updateUserInfo?"+all_param);
        let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.APP_KEY}&redirect_uri=${ENCode_URL}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`
        window.location.replace(url)
    }
    // 判断请求状态
    if( res.data.code == 1000 ){
        // 成功则存储token并返回
        sessionStorage.setItem('x-token', token)
    }else{
        // 输出错误信息
        if(res.status == 200 ){
            alert(res.data.message)
        }else{
            alert(`${res.status}::${res.statusText}`)
        }
    }
    return token;
}
export default get_token;